import http_helper from "../../../base/http_helper"
import _skeleton from "../../skeleton/skeleton"

export default{
    types: [],
    category:"",
    type:"",
    message:"",
    submit_button: {
        text: 'REPORTAR',
        element: undefined
    },
    build(model, container, station_prefix_id){
        this.showSkeleton(container)
        this.category = ""
        this.type = ""
        this.message = ""
        this.container = container
        http_helper.get("/sibh/api/v1/types/from_model", {model: model}).then(data=>{
            this.types = data
            let categories = this.getAllCategories(data)
            $(container).html("<form>"+
                "<div class='form-group form-group-categories'><label>Categoria</label>"+this.buildCategorySelect(categories)+"</div>"+
                "<div class='form-group form-group-types'><label>Tipo report</label>"+this.buildTypesSelect()+"</div>"+
                "<div class='form-group form-group-messages'><label>Mensagem</label><textarea class='form-control message'></textarea></div>"+
                "<div class='form-group form-group-submit'><button class='btn btn-info btn-block btn-sm btn-submit' type='button'>"+this.submit_button.text+"</button></div>"+
            "</form>")
            this.submit_button.element = $(container).find(".form-group-submit button.btn-submit")[0]
            $(container).find(".form-group select").select2({theme: 'bootstrap4'})
            this.manageForm()


            // DELEGATE ALL SELECTS
            $(container).find('.form-group select').on('change',e=>{
                let value = e.target.value //valor da caixa
                let current = e.target.dataset.current //informação alterada
                let target = e.target.dataset.target //proxima caixa
                this[current] = value
                this.manageSelect(target)
                this.manageForm()
            })
            $(container).find('.form-group textarea').on('keyup', e=>{
                let value = e.target.value
                this.message = ''
                if(value != ''){
                    this.message = value
                }
                this.manageForm()
            })
            $(container).find('.form-group button.btn-submit').on('click', e=>{
                let buildReportParams = () =>{
                    //console.log(station_prefix_id)
                    return {type_id: this.type, message: this.message, reportable_type: model, reportable_id: station_prefix_id}
                }
                let buttonState = state =>{
                    if(state == "loading"){
                        this.submit_button.element.disabled = true
                        this.submit_button.element.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
                    } else if(state == "default"){
                        this.submit_button.element.disabled = false
                        this.submit_button.element.innerHTML = this.submit_button.text
                    }
                }
                buttonState('loading')
                http_helper.request('/sibh/api/v1/reports/create', buildReportParams(), 'POST').then(data=>{
                    toast.info('Problema reportado! Agradecemos o apoio')
                    $(container).trigger('report_created', [data])
                }).fail(data=>{
                    if(data.status == 422){
                        let html = ""
                        $.each(data.responseJSON, function(field, message){
                            html += field +": "+message+"<br>"
                        })
                        toast.warning(html)        
                    } else {
                        toast.warning(data.responseJSON.error)
                    }                    
                }).always(data=>{
                    buttonState('default')
                })
            })
        })
    },
    buildCategorySelect(categories){
        let html =  "<select data-width='100%' class='form-control' data-current='category' data-target='types'>";
        html += "<option value='' disabled hidden selected></option>" //adicionando uma option em branco escondida selecionada
        $.each(categories, (index, category)=>{
            html += "<option>"+category+"</option>"
        })
        return html += "</select>"
    },
    buildTypesSelect(){
        let html =  "<select data-width='100%' class='form-control' data-current='type' data-target='messages'>";
        $.each(this.types, (index, type)=>{
            if(this.category == type.category){
                html += "<option>"+type.name+"</option>"
            }
        })
        return html += "</select>"
    },
    manageForm(){
        //this.hideAllGroups()
        this.showGroup('categories')
        if(this.category != ""){
            //this.type = ""
            if(!this.isGroupVisible('types')){
                this.showGroup('types')
            }
        } else {
            this.hideGroup('types')
        }
        if(this.type != ""){
            //this.message = ""
            if(!this.isGroupVisible('messages')){
                this.showGroup('messages')
            }
        }else {
            this.hideGroup('messages')
        }
        if(this.message != ""){
            //this.message = ""
            if(!this.isGroupVisible('submit')){
                this.showGroup('submit')
            }
        }else {
            this.hideGroup('submit')
        }
    },
    getAllCategories(types){
        return [...new Set(types.map(x=>x.category))]
    },
    showGroup(group){
        $(this.container).find('.form-group-'+group).show()
        // $(this.container).find('.form-group-'+group).animate({
        //     //opacity: 1,
        //     height: "show"
        // }, {
        //     duration: 100
        // })
    },
    hideGroup(group){
        $(this.container).find('.form-group-'+group).hide()
        // $(this.container).find('.form-group-'+group).animate({
        //     //opacity: 1,
        //     height: "hide"
        // }, {
        //     duration: 100
        // })
    },
    hideAllGroups(){
        $(this.container).find('.form-group').hide()
    },
    manageSelect(select_name){
        switch(select_name){
            case 'types':
                this.type = ""
                this.message = ""
                this.fillOptions('.form-group.form-group-types select', this.types.map(x=>({id: x.id, text: x.name})))
                break;
            case 'messages':
                this.message = ""
                $(this.container).find('.form-group textarea.message').val("")
                break;
            default :
                null
        }
    },
    fillOptions(select_id,options){
        $(select_id).empty()
        $(select_id).append("<option value='' disabled hidden selected></option>") //adicionando uma option em branco escondida selecionada
        $(select_id).select2({data: options, theme: 'bootstrap4'})
    },
    showSkeleton(container){
        $(container).html(_skeleton.buildHTML('lg'))
    },
    isGroupVisible(group){
        $(this.container).find('.form-group-'+group).is(":visible");
    }
}